import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { OrderBillDetailsBus } from "./OrderBillDetailsBus";
import { OrderBillPaymentsBus } from "./OrderBillPaymentsBus";
import { DateFunctions } from "../static/date-functions";
import { CommonValues } from "../static/CommonValues";

export class OrderBillBus extends BaseBus
{
    CID(): any {
        return this.orderBillId;
    }
    constructor(data: OrderBillBus = null, setEmptyGuidToNull: boolean = true) {
        super(data, setEmptyGuidToNull);
        if (!CommonFunctions.hasArrayElementValue(this.orderBillDetails)) {
            this.orderBillDetails = [];
        }
            
        if (!CommonFunctions.hasArrayElementValue(this.orderBillPayments)) {
                this.orderBillPayments = [];
        }
    }
    initialize(data: OrderBillBus) {
        super.initialize(data);
        try {
            this.insertDt = CommonFunctions.getDate(data.insertDt);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
            this.dateReceived = CommonFunctions.getDate(data.dateReceived);
            this.sageDt = CommonFunctions.getDate(data.sageDt);
            
            if (CommonFunctions.hasArrayElementValue(data.orderBillDetails)) {
                let arr = [];
                for (let i = 0; i < data.orderBillDetails.length; i++) {
                    let busObj: OrderBillDetailsBus = new OrderBillDetailsBus(data.orderBillDetails[i]);
                    
                    arr.push(busObj);
                }                    
                this.orderBillDetails = arr;
            }
            if (CommonFunctions.hasArrayElementValue(data.orderBillPayments)) {
                let arr = [];
                for (let i = 0; i < data.orderBillPayments.length; i++) {
                    let busObj: OrderBillPaymentsBus = new OrderBillPaymentsBus(data.orderBillPayments[i]);
                    if (!busObj.paidById) { busObj.paidById = CommonValues.Guid_Empty; }
                    arr.push(busObj);
                }
                this.orderBillPayments = arr;
            }
        }
        catch {

        }

    }
    setChildrenToUpdatedAdded() {
        this.orderBillDetails = this.orderBillDetails.filter(s => (s.isUpdated === true || s.isAdded === true) && s.originalQuantityBilled !== s.quantityBilled);
        this.orderBillPayments = this.orderBillPayments.filter(s => s.isUpdated === true || s.isAdded === true);
    }
    setId(id: any) {
        this.orderBillId = id;
    }
    setParentId(id: any) {
        this.orderId = id;
    }
    setFromForm(data: OrderBillBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();
        if (this.hasId) {
            this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.dateReceived = DateFunctions.getDateTimeWithUTCOffset(this.dateReceived);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateDt = date;
            this.updateUserId = userId;
            this.insertDt = date;
            this.insertUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
            this.updateDt = date;
            this.updateUserId = userId;
        }
    }
    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }
    get hasUpdatedChildren(): boolean {
        let hasUC: boolean = false;
        if (CommonFunctions.hasArrayElementValue(this.orderBillDetails)) {
            var od = this.orderBillDetails.filter(s => (s.isUpdated === true || s.isAdded === true) && s.originalQuantityBilled !== s.quantityBilled);
            if (CommonFunctions.hasArrayElementValue(od)) {
                hasUC = true;
            }
        }
        if (!hasUC) {
            if (CommonFunctions.hasArrayElementValue(this.orderBillPayments)) {
                var op = this.orderBillPayments.filter(s => s.isUpdated === true || s.isAdded === true);
                if (CommonFunctions.hasArrayElementValue(op)) {
                    hasUC = true;
                }
            }

        }
        return hasUC;
    }
    orderBillId: any;
    orderId: any;
    dateReceived: Date;
    receivedById: any;
    amountBilled: number;
    orderBillStatusId: any;
    referenceNumber: string;
    qbid: string;
    qbeditSequenceId: string;
    insertDt: Date;
    insertUserId: any;
    updateDt: Date;
    updateUserId: any;
    sageDt: Date;
    orderBillDetails: OrderBillDetailsBus[];
    orderBillPayments: OrderBillPaymentsBus[];
    rowValid: boolean = false;
    dataLoading: boolean = false;
    hasInvoice: boolean = false;
    oicInvoiceId: string;
    public static getUpdatedAdded(busObjs: OrderBillBus[]) : OrderBillBus[] {
        let arr: OrderBillBus[] = [];
        if (CommonFunctions.hasArrayElementValue(busObjs)) {
            for (let i = 0; i < busObjs.length; i++) {
                if (busObjs[i].hasUpdatedChildren) {
                    let busObj: OrderBillBus = new OrderBillBus(busObjs[i],false);
                    busObj.setChildrenToUpdatedAdded();
                    arr.push(busObj);
                }
            }
        }
        return arr;
    }
}
